document.body.addEventListener('click', (e) => {
  if (e.target.hasAttribute('data-quickview')) {
        e.preventDefault()
        const btn = $(e.target)
        $(btn).off()
        const _target = $('#quickview-modal')
        const handle = $(btn).attr('data-handle')
        const id = $(btn).attr('data-product-id')
        const productScript = _target.attr('data-quickview-product-script')
        const close = '<button type="button" class="quickview-modal__close" aria-label="Close quick shop" data-quickview-modal-close></button>'
        const overlay = '<button type="button" class="quickview-modal__overlay" aria-label="Close quick shop" data-quickview-modal-close></button>'
        $('body').addClass('modal-active')
        _target.innerHTML = ''
        _target.append(overlay)
  
        $.ajax({
          url: `/products/${handle}`,
          success: function(response) {
            const content = $('<div />').html(response)
            const product = content.find('[data-product]')
            const productInner = content.find('.product__inner')
            const title = content.find('.product__title').clone(true)
            title.attr('id', 'modal-label')
            title.removeClass('product__title')
            title.addClass('visually-hidden')
            product.addClass('loading')
            productInner.prepend(close)
            _target.append(title)
            _target.append(product)
  
            $('<script>')
              .attr('type', 'text/javascript')
              .attr('src', productScript)
              .appendTo(product)
  
            const interval = setInterval(() => {
              let p = document.querySelector("[data-product-json]").innerHTML
              p = JSON.parse(p || '{}')
  
              if (typeof Shopify.OptionSelectors !== 'undefined') {
                new Shopify.OptionSelectors('product-select', {
                  product: p,
                  onVariantSelected: window.selectCallback
                })
                clearInterval(interval)
              }
            }, 100)
  
  
            setTimeout(() => {
              const config = {
                productId: parseInt(id), 
                injectionParent: '#quickview-modal form[action="/cart/add"]',
                injectionMethod: 'prepend',
                injectFn: (node, target) => {},
                selectors: {
                  price: ['#quickview-modal [data-product-price]'], 
                  variant: ['#quickview-modal .single-option-selector'] 
                }
              }
              const widget = window.ReChargeWidget.createWidget(config)
            }, 500)
  
            window.mediaSlider()
  
            setTimeout(() => {
              product.removeClass('loading')
              const closeBtn = $(_target).find('.quickview-modal__close')[0]
              closeBtn.focus()
            }, 100)
            
            const handleCloseModal = () => {
              const closeBtn = $(_target).find('.quickview-modal__overlay')[0]
              $('body').removeClass('modal-active')
              product.remove()
              closeBtn.remove()
              $('.quickview-modal #modal-label').remove()
            }

            $('[data-quickview-modal-close]').on('click', function() {
              handleCloseModal()
            })

            window.addEventListener('keyup', (e) => {
              if (e.key === 'Escape') {
                handleCloseModal()
              }
            })
          }
        })
      }
  })
